import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BillingAutoPayDataAccessModule } from '@amfam/billing/auto-pay/data-access';
import { BillingAutoPayDetailUiModule } from '@amfam/billing/auto-pay/detail/ui';
import {
  AutoPaySetupStateModule,
  BillingAutoPayFeatureModule
} from '@amfam/billing/auto-pay/feature';
import { BillingAutoPayUiModule } from '@amfam/billing/auto-pay/ui';
import { BillingPaymentMethodFeatureModule } from '@amfam/billing/payment-method/feature';
import { BillingSharedUiModule } from '@amfam/billing/shared/ui';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { AutoPayDeleteConfirmationWrapperComponent } from './containers/auto-pay-delete-confirmation-wrapper/auto-pay-delete-confirmation-wrapper.component';
import { AutoPayDeleteModalWrapperComponent } from './containers/auto-pay-delete-modal-wrapper/auto-pay-delete-modal-wrapper.component';
import { AutoPayDetailWrapperComponent } from './containers/auto-pay-detail-wrapper/auto-pay-detail-wrapper.component';
import { AutoPayDeleteRoutingModule } from './routing/auto-pay-routing.module';

@NgModule({
  imports: [
    CommonModule,
    AutoPayDeleteRoutingModule,
    UiKitModule,
    SharedServicesModule,
    FormsModule,
    ReactiveFormsModule,
    BillingAutoPayUiModule,
    BillingAutoPayDataAccessModule,
    BillingSharedUiModule,
    BillingAutoPayDetailUiModule,
    PipesModule,
    AutoPaySetupStateModule,
    BillingAutoPayFeatureModule,
    BillingPaymentMethodFeatureModule
  ],
  declarations: [
    AutoPayDeleteConfirmationWrapperComponent,
    AutoPayDeleteModalWrapperComponent,
    AutoPayDetailWrapperComponent
  ],
  exports: [
    AutoPayDeleteConfirmationWrapperComponent,
    AutoPayDeleteModalWrapperComponent,
    AutoPayDetailWrapperComponent
  ]
})
export class BillingAutoPayDetailFeatureModule {}
